import React, { Component } from "react";
import { vrijwilligers } from "../../models/firestore";
import Vrijwilliger from "./Vrijwilliger";
import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";
import { withStyles } from "@material-ui/core/styles";
import { observer } from "mobx-react";
import ReactTable from "react-table";
import "react-table/react-table.css";
import matchSorter from "match-sorter";

const styles = {
  container: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    position: "relative"
  },
  loader: {
    position: "absolute",
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center"
  },
  header: {
    padding: 16,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    borderBottom: "1px solid #DDD"
  },
  content: {
    flex: 1,
    overflowY: "scroll"
  },
  add: {
    position: "absolute",
    top: 0,
    right: 0,
    height: 20
  }
};
const Vrijwilligers = observer(
  class Vrijwilligers extends Component {
    constructor(props) {
      super(props);
      this.state = {
        disabled: false,
        displayNaam: "",
        rollen: ""
      };
    }
    componentDidMount() {
      // const editable =
      //   this.props.gebruikersrollen.search("admin") > -1 ||
      //   this.props.gebruikersrollen.search("kantoor") > -1;
      // this.setState({
      //   disabled: !editable
      // });
    }

    onPressAdd = async () => {
      try {
        await vrijwilligers.add({
          voornaam: "Nieuw",
          beschikbaarheid: {
            morgen: {
              1: true,
              2: true,
              3: true,
              4: true,
              5: true,
              6: true,
              7: true
            },
            middag: {
              1: true,
              2: true,
              3: true,
              4: true,
              5: true,
              6: true,
              7: true
            },
            avond: {
              1: true,
              2: true,
              3: true,
              4: true,
              5: true,
              6: true,
              7: true
            }
          }
        });
      } catch (err) {
        alert(err);
      }
    };

    onPressDelete = async row => {
      if (
        window.confirm("Weet u zeker dat u deze vrijwilliger wilt verwijderen?")
      ) {
        //console.log(row.original.ID);

        //console.log(row.original.vrijwilliger);
        if (this._deleting) return;
        this._deleting = true;
        try {
          if (row.original.vrijwilliger.data.rollen) {
            alert(
              "Vrijwilliger heeft rollen (" +
                row.original.vrijwilliger.data.rollen +
                ") en kan niet verwijderd worden. Contact Pierre!!"
            );
          } else {
            await row.original.vrijwilliger.delete();
            this._deleting = false;
          }
        } catch (err) {
          this._deleting = false;
        }
      }
    };

    render() {
      //let gebruikersNaam = "";
      //let gebruikersrollen = "";
      //const { disabled } = this.state;
      let children = [];
      const { classes, gebruikersNaam, gebruikersrollen } = this.props;
      const { docs } = vrijwilligers;

      //Moet hier nog een promise omheen ????

      //const { isLoading } = vrijwilligers;

      // range = len => {
      //   const arr = [];
      //   for (let i = 0; i < len; i++) {
      //     arr.push(i);
      //   }
      //   return arr;
      // };

      // newPerson = vw => {
      //   const statusChance = Math.random();
      //   return {
      //     voornaam: vw.voornaam,
      //     achternaam: vw.achternaam
      //   };
      // };

      // makeData() {
      //   return docs.map(d => {
      //     return {
      //       ...newPerson(d),
      //       children: range(10).map(newPerson)
      //     };
      //   });
      // }

      children = docs.map(function(vrijwilliger) {
        return {
          voornaam: vrijwilliger.data.voornaam,
          achternaam: vrijwilliger.data.tussenvoegsel
            ? vrijwilliger.data.tussenvoegsel +
              " " +
              vrijwilliger.data.achternaam
            : vrijwilliger.data.achternaam,
          telefoon: vrijwilliger.data.telefoon,
          backuptelefoon: vrijwilliger.data.backuptelefoon,
          email: vrijwilliger.data.email,
          ID: vrijwilliger.id,
          Chauffeur: vrijwilliger.data.Chauffeur ? "Ja" : "Nee",
          Boodschap: vrijwilliger.data.Boodschap ? "Ja" : "Nee",
          ChauffeurInstellingen: vrijwilliger.data.ChauffeurInstellingen
            ? "Ja"
            : "Nee",
          Electra: vrijwilliger.data.Electra ? "Ja" : "Nee",
          Techniek: vrijwilliger.data.Techniek ? "Ja" : "Nee",
          Timmeren: vrijwilliger.data.Timmeren ? "Ja" : "Nee",
          Wandelen: vrijwilliger.data.Wandelen ? "Ja" : "Nee",
          Tuin: vrijwilliger.data.Tuin ? "Ja" : "Nee",
          Lief_en_leed: vrijwilliger.data.Lief_en_leed ? "Ja" : "Nee",
          PR: vrijwilliger.data.PR ? "Ja" : "Nee",
          Algemeneklusjes: vrijwilliger.data.Algemeneklusjes ? "Ja" : "Nee",
          KlussenInstellingen: vrijwilliger.data.KlussenInstellingen
            ? "Ja"
            : "Nee",
          Telefoondienst: vrijwilliger.data.Telefoondienst ? "Ja" : "Nee",
          vrijwilliger: vrijwilliger
        };
      });

      return (
        <div>
          <div align="right" style={{ paddingRight: 20, paddingBottom: 15 }}>
            <Button
              //variant="fab"
              variant="contained"
              size="medium"
              color="primary"
              //aria-label="add"
              className={classes.button}
              disabled={
                this.props.gebruikersrollen.search("editvrijwilligers") === -1
              }
              onClick={this.onPressAdd}
              style={{ marginTop: 10 }}
            >
              Voeg vrijwilliger toe
            </Button>
          </div>
          <ReactTable
            data={children}
            previousText="Vorige"
            nextText="Volgende"
            loadingText="Laden..."
            noDataText="Geen rijen gevonden"
            pageText="Pagina"
            ofText="van"
            rowsText="rijen"
            filterable
            defaultFilterMethod={(filter, row) =>
              String(row[filter.id]) === filter.value
            }
            SubComponent={row => {
              return (
                <Vrijwilliger
                  key={row.original.ID}
                  vrijwilliger={row.original.vrijwilliger}
                  gebruikersNaam={gebruikersNaam}
                  gebruikersrollen={gebruikersrollen}
                />
              );
            }}
            columns={[
              {
                Header: "ID",
                columns: [
                  {
                    Header: "ID",
                    accessor: "ID",
                    width: 50,
                    filterable: false,
                    show: false
                  }
                ]
              },

              // {
              //   Header: "Email",
              //   columns: [
              //     {
              //       Header: "Email",
              //       accessor: "email",
              //       width: 100,
              //       filterMethod: (filter, rows) =>
              //         matchSorter(rows, filter.value, { keys: ["email"] }),
              //       filterAll: true
              //     },
              //     {
              //       Header: "Achternaam",
              //       accessor: "achternaam",
              //       width: 150,

              //       filterMethod: (filter, rows) =>
              //         matchSorter(rows, filter.value, { keys: ["achternaam"] }),
              //       filterAll: true
              //     }
              //   ]
              // },
              {
                Header: "Naam",
                columns: [
                  {
                    Header: "Voornaam",
                    accessor: "voornaam",
                    width: 100,
                    filterMethod: (filter, rows) =>
                      matchSorter(rows, filter.value, { keys: ["voornaam"] }),
                    filterAll: true
                  },
                  {
                    Header: "Achternaam",
                    accessor: "achternaam",
                    width: 150,

                    filterMethod: (filter, rows) =>
                      matchSorter(rows, filter.value, { keys: ["achternaam"] }),
                    filterAll: true
                  }
                ]
              },
              {
                Header: "Telefoon",
                columns: [
                  {
                    Header: "Telefoon",
                    accessor: "telefoon",
                    width: 100,
                    filterMethod: (filter, rows) =>
                      matchSorter(rows, filter.value, { keys: ["telefoon"] }),
                    filterAll: true
                  },
                  {
                    Header: "BackupTelefoon",
                    accessor: "backuptelefoon",
                    width: 100,
                    filterable: false
                  }
                ]
              },
              {
                Header: "Geschikt voor:",
                columns: [
                  {
                    Header: "Tel dienst",
                    accessor: "Telefoondienst",
                    width: 70,
                    Cell: row => (
                      <span>
                        <span
                          style={{
                            color: row.value === "Ja" ? "#57d500" : "#ff0000",
                            transition: "all .3s ease"
                          }}
                        >
                          &#x25cf;
                        </span>{" "}
                        {row.value}
                      </span>
                    ),
                    filterMethod: (filter, rows) =>
                      matchSorter(rows, filter.value, {
                        keys: ["Telefoondienst"]
                      }),
                    filterAll: true
                  },
                  {
                    Header: "Chauffeur",
                    accessor: "Chauffeur",
                    width: 70,
                    Cell: row => (
                      <span>
                        <span
                          style={{
                            color: row.value === "Ja" ? "#57d500" : "#ff0000",
                            transition: "all .3s ease"
                          }}
                        >
                          &#x25cf;
                        </span>{" "}
                        {row.value}
                      </span>
                    ),
                    filterMethod: (filter, rows) =>
                      matchSorter(rows, filter.value, {
                        keys: ["Chauffeur"]
                      }),
                    filterAll: true
                  },
                  {
                    Header: "Ch inst",
                    accessor: "ChauffeurInstellingen",
                    width: 70,
                    Cell: row => (
                      <span>
                        <span
                          style={{
                            color: row.value === "Ja" ? "#57d500" : "#ff0000",
                            transition: "all .3s ease"
                          }}
                        >
                          &#x25cf;
                        </span>{" "}
                        {row.value}
                      </span>
                    ),
                    filterMethod: (filter, rows) =>
                      matchSorter(rows, filter.value, {
                        keys: ["ChauffeurInstellingen"]
                      }),
                    filterAll: true
                  },
                  {
                    Header: "Boodschap",
                    accessor: "Boodschap",
                    width: 70,
                    Cell: row => (
                      <span>
                        <span
                          style={{
                            color: row.value === "Ja" ? "#57d500" : "#ff0000",
                            transition: "all .3s ease"
                          }}
                        >
                          &#x25cf;
                        </span>{" "}
                        {row.value}
                      </span>
                    ),
                    filterMethod: (filter, rows) =>
                      matchSorter(rows, filter.value, {
                        keys: ["Boodschap"]
                      }),
                    filterAll: true
                  },
                  {
                    Header: "Electra",
                    accessor: "Electra",
                    width: 70,
                    Cell: row => (
                      <span>
                        <span
                          style={{
                            color: row.value === "Ja" ? "#57d500" : "#ff0000",
                            transition: "all .3s ease"
                          }}
                        >
                          &#x25cf;
                        </span>{" "}
                        {row.value}
                      </span>
                    ),
                    filterMethod: (filter, rows) =>
                      matchSorter(rows, filter.value, {
                        keys: ["Electra"]
                      }),
                    filterAll: true
                  },
                  {
                    Header: "Techniek",
                    accessor: "Techniek",
                    width: 70,
                    Cell: row => (
                      <span>
                        <span
                          style={{
                            color: row.value === "Ja" ? "#57d500" : "#ff0000",
                            transition: "all .3s ease"
                          }}
                        >
                          &#x25cf;
                        </span>{" "}
                        {row.value}
                      </span>
                    ),
                    filterMethod: (filter, rows) =>
                      matchSorter(rows, filter.value, {
                        keys: ["Techniek"]
                      }),
                    filterAll: true
                  },
                  {
                    Header: "Timmeren",
                    accessor: "Timmeren",
                    width: 70,
                    Cell: row => (
                      <span>
                        <span
                          style={{
                            color: row.value === "Ja" ? "#57d500" : "#ff0000",
                            transition: "all .3s ease"
                          }}
                        >
                          &#x25cf;
                        </span>{" "}
                        {row.value}
                      </span>
                    ),
                    filterMethod: (filter, rows) =>
                      matchSorter(rows, filter.value, {
                        keys: ["Timmeren"]
                      }),
                    filterAll: true
                  },
                  {
                    Header: "Wandelen",
                    accessor: "Wandelen",
                    width: 70,
                    Cell: row => (
                      <span>
                        <span
                          style={{
                            color: row.value === "Ja" ? "#57d500" : "#ff0000",
                            transition: "all .3s ease"
                          }}
                        >
                          &#x25cf;
                        </span>{" "}
                        {row.value}
                      </span>
                    ),
                    filterMethod: (filter, rows) =>
                      matchSorter(rows, filter.value, {
                        keys: ["Wandelen"]
                      }),
                    filterAll: true
                  },
                  {
                    Header: "Tuin",
                    accessor: "Tuin",
                    width: 70,
                    Cell: row => (
                      <span>
                        <span
                          style={{
                            color: row.value === "Ja" ? "#57d500" : "#ff0000",
                            transition: "all .3s ease"
                          }}
                        >
                          &#x25cf;
                        </span>{" "}
                        {row.value}
                      </span>
                    ),
                    filterMethod: (filter, rows) =>
                      matchSorter(rows, filter.value, {
                        keys: ["Tuin"]
                      }),
                    filterAll: true
                  },
                  {
                    Header: "Lief Leed",
                    accessor: "Lief_en_leed",
                    width: 70,
                    Cell: row => (
                      <span>
                        <span
                          style={{
                            color: row.value === "Ja" ? "#57d500" : "#ff0000",
                            transition: "all .3s ease"
                          }}
                        >
                          &#x25cf;
                        </span>{" "}
                        {row.value}
                      </span>
                    ),
                    filterMethod: (filter, rows) =>
                      matchSorter(rows, filter.value, {
                        keys: ["Lief_en_leed"]
                      }),
                    filterAll: true
                  },
                  {
                    Header: "PR",
                    accessor: "PR",
                    width: 70,
                    Cell: row => (
                      <span>
                        <span
                          style={{
                            color: row.value === "Ja" ? "#57d500" : "#ff0000",
                            transition: "all .3s ease"
                          }}
                        >
                          &#x25cf;
                        </span>{" "}
                        {row.value}
                      </span>
                    ),
                    filterMethod: (filter, rows) =>
                      matchSorter(rows, filter.value, {
                        keys: ["PR"]
                      }),
                    filterAll: true
                  },
                  {
                    Header: "Algemene klusjes",
                    accessor: "Algemeneklusjes",
                    width: 70,
                    Cell: row => (
                      <span>
                        <span
                          style={{
                            color: row.value === "Ja" ? "#57d500" : "#ff0000",
                            transition: "all .3s ease"
                          }}
                        >
                          &#x25cf;
                        </span>{" "}
                        {row.value}
                      </span>
                    ),
                    filterMethod: (filter, rows) =>
                      matchSorter(rows, filter.value, {
                        keys: ["Algemeneklusjes"]
                      }),
                    filterAll: true
                  },
                  {
                    Header: "Klussen Instellingen",
                    accessor: "KlussenInstellingen",
                    width: 70,
                    Cell: row => (
                      <span>
                        <span
                          style={{
                            color: row.value === "Ja" ? "#57d500" : "#ff0000",
                            transition: "all .3s ease"
                          }}
                        >
                          &#x25cf;
                        </span>{" "}
                        {row.value}
                      </span>
                    ),
                    filterMethod: (filter, rows) =>
                      matchSorter(rows, filter.value, {
                        keys: ["KlussenInstellingen"]
                      }),
                    filterAll: true
                  }
                  //,
                  // {
                  //   Header: "BackupTelefoon",
                  //   accessor: "backuptelefoon",
                  //   width: 100,
                  //   filterable: false
                  // }
                ]
              }
            ]}
            defaultSorted={[
              {
                id: "achternaam",
                desc: false
              }
            ]}
            defaultPageSize={20}
            className="-striped -hightlight"
          />
          <Paper
            style={{ marginLeft: "200px", marginRight: "200px", marginTop: 30 }}
          >
            U bent ingelogd als {gebruikersNaam} en heeft de rollen{" "}
            {gebruikersrollen}
          </Paper>
        </div>
      );
    }
  }
);

export default withStyles(styles)(Vrijwilligers);



// WEBPACK FOOTER //
// ./src/components/Vrijwilligers/Vrijwilligers.jsx